const newsId = 2 // 新闻id
const specialId = 1 // 专题id

export default {
  newsId,
  specialId
}